
import React, { useState, useEffect,useRef } from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
  useNavigate,
  useParams,
  useLocation,
  Navigate
} from 'react-router-dom';


// Локальные импорты
import { useGame, GameProvider } from './context/GameContext'; 
import socket from './socket';
import axios from 'axios';
import tournamentSocket from './tournamentSocket';
import longSocket from './longSocket';
import Khachapuri from './Khachapuri';
import SpinWheelOverlay from './SpinWheelOverlay';
import Login from './Login';
import Register from './Register';
import Lobby from './Lobby';
import Game from './Game';
import TournamentsPage from './TournamentsPage';
import TournamentMatch from './TournamentMatch';
import LongBackgammon from './LongBackgammon';
import ShortBackgammonBoard from './ShortBackgammonBoard';
import AdminPanel from './AdminPanel';
import Layout from './Layout'; // <-- наш общий макет
import Profile from './Profile';

import SiteBannerPopup
  from './components/SiteBannerPopup';
import PresenceHeartbeat
  from './components/PresenceHeartbeat';

import LongTournamentBackgammon from './LongTournamentBackgammon';
import { useTournamentSocket } from './hooks/useTournamentSocket';
import longTournamentSocket, { ensureLongSocket } from './longTournamentSocket';

import BigTournamentBackgammon
  from './BigTournamentBackgammon';


  import BigTournamentShortMatch
  from './BigTournamentShortMatch';


import bigTournamentLongSocket
  from './bigTournamentLongSocket';

import bigTournamentShortSocket, {
  ensureBigTournamentShortSocketAuthAndConnect,
} from './bigTournamentShortSocket';

import Quests from './components/Quests';
import { SoundProvider } from './sfx/SoundProvider'; // ← твой путь
import ProfileLayout from './ProfileLayout';
import { PokerProvider } from './poker/context/PokerContext';
import PokerLobby from './poker/PokerLobby';
import PokerTable from './poker/PokerTable';
import ForgotPassword from './ForgotPassword';



import SatellitesPage from './satellites/SatellitesPage';
import SatelliteDetails from './satellites/SatelliteDetails';

import BigTournamentsPage
  from './bigTournaments/BigTournamentsPage';
import {DrawBracketsHome, DrawBracketsDetail} from './drawBrackets/DrawBracketsPage';

  import BigTournamentDetails
  from './bigTournaments/BigTournamentDetails';
// import Header from './Header'; // если захотите напрямую 

const AppContent = () => {
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('');  // <-- Добавили
  

  const [showWheel, setShowWheel] = useState(false);
  const [wheelAngle, setWheelAngle] = useState(0);
  const [userAvatar, setUserAvatar] = useState('');
  const [userBalance, setUserBalance] = useState(null); 
  const [userAssets, setUserAssets] = useState({ tickets: [], skins: [] });

  const { tables, setTables } = useGame();
  const navigate = useNavigate();
 const tournamentSocket = useTournamentSocket()
const lastBalanceUpdateRef = useRef({ ts: 0, src: 'init' });


 const API_ORIGIN = process.env.REACT_APP_API_URL;   // например: http://147.93.123.26:5000
const API_BASE   = `${API_ORIGIN}/api`;


//  const alreadyJoinedTournamentRef = useRef(false);
const joinedTablesRef = useRef(new Set());

const usernameRef = useRef('');
useEffect(() => {
  usernameRef.current = username;
}, [username]);



const handleLogout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  localStorage.removeItem('role');

  localStorage.removeItem(
    'bigTournament:lastActiveTableId'
  );

  sessionStorage.removeItem(
    'bigTournament:lastActiveTableId'
  );

  window.location.href = '/';
};
 





  useEffect(() => {
  const token = localStorage.getItem('token') || '';
  const username = localStorage.getItem('username') || '';

  // выставляем оба поля, чтобы бэку было и кто, и с каким токеном
  try {
    longTournamentSocket.auth = { token, username };
  } catch {}

  // гарантированный коннект
  if (!longTournamentSocket.connected && !longTournamentSocket.connecting) {
    longTournamentSocket.connect();
  }
}, []);





useEffect(() => {
  const ask = () => {
    longTournamentSocket.emit('long_getMyActiveTable', (resp) => {
      if (resp?.tableId) {
        navigate(`/long-tournament/table?tableId=${resp.tableId}`);
      }
    });
  };

  if (longTournamentSocket.connected) {
    ask();               // если уже подключены – спросить сразу
  }
  longTournamentSocket.on('connect', ask); // и на каждый последующий connect

  return () => {
    longTournamentSocket.off('connect', ask);
  };
}, [navigate]);




  useEffect(() => {
    longSocket.connect();
    return () => {
      longSocket.disconnect();
    };
  }, []);



// useEffect(() => {
//   const token = localStorage.getItem('token');
//   if (!token) return;

//   try {
//     socket.auth = { token };
//     longSocket.auth = { token };
//     tournamentSocket.auth = { token };
//     // longTournamentSocket.auth = { token };
//     longTournamentSocket.auth = { token, username: localStorage.getItem('username') || '' };
//   } catch {}

//   if (!socket.connected && !socket.connecting) socket.connect();
//   if (!longSocket.connected && !longSocket.connecting) longSocket.connect();
//   if (!tournamentSocket.connected && !tournamentSocket.connecting) tournamentSocket.connect();
//   if (!longTournamentSocket.connected && !longTournamentSocket.connecting) longTournamentSocket.connect();
// }, []);
useEffect(() => {
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('username') || '';
  if (!token) return;

  try {
    socket.auth = { token };
    longSocket.auth = { token };

    // ⛔ БОЛЬШЕ НЕ ТРОГАЕМ tournamentSocket ЗДЕСЬ
    // tournamentSocket.auth = { token };

    // longTournamentSocket.auth = { token };
    longTournamentSocket.auth = { token, username };
  } catch {}

  if (!socket.connected && !socket.connecting) socket.connect();
  if (!longSocket.connected && !longSocket.connecting) longSocket.connect();

  // ⛔ И КОННЕКТ ТУРНИРНОГО СОКЕТА ТОЖЕ УБИРАЕМ
  // if (!tournamentSocket.connected && !tournamentSocket.connecting) {
  //   tournamentSocket.connect();
  // }

  if (!longTournamentSocket.connected && !longTournamentSocket.connecting) {
    longTournamentSocket.connect();
  }
}, []); // зависимости можно оставить пустые, как и было



socket.on('forceReload', (payload) => {
  console.log('[SIO] forceReload', payload);
  window.location.reload();
});



useEffect(() => {
  const onForceLogout = (payload) => {
    console.log('[auth] forceLogout from server', payload);

    // ВАЖНО: не трогаем localStorage, иначе выкинет и вторую вкладку тоже
    // Просто "убиваем" соединения и уводим на логин

    try { socket.disconnect(); } catch (e) {}
    try { longSocket.disconnect(); } catch (e) {}
    try { tournamentSocket.disconnect(); } catch (e) {}
    // если есть еще сокеты — тоже отключи

    // Увести на страницу авторизации
    window.location.replace('/login');
  };

  socket.on('forceLogout', onForceLogout);

  return () => {
    socket.off('forceLogout', onForceLogout);
  };
}, []);



  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUsername = localStorage.getItem('username');
    const savedRole = localStorage.getItem('role');
  
    if (savedToken) {
      setToken(savedToken);
      setUsername(savedUsername);
      setRole(savedRole || '');
  
      if (savedUsername) {
        socket.emit('getUserBalance', { username: savedUsername });
      }
  
      // ⬇️ ВСТАВЬ ЗДЕСЬ
      axios.get(`${API_BASE}/profile`, {
      headers: { Authorization: `Bearer ${savedToken}` }
    })

      .then(res => {
        setUserAvatar(res.data.avatar); // 👈 сохраняем путь к аватарке
      })
      .catch(err => {
        console.error('Ошибка при получении профиля:', err);
      });
    }
  }, []);




  // 2) полуфинал/финал
  useEffect(() => {
    if (!username) return;
 function handleSemifinalsStarted({ tournamentId, gameType, semifinalTables }) {
  // const found = semifinalTables.find(
  //   (pair) => pair.player1 === username || pair.player2 === username
  // );
  const found = semifinalTables.find(m =>
  [m.player1, m.player2, m.player1Name, m.player2Name].includes(username)
);

  if (found) {
    const routeBase = gameType === 'long' ? 'longTournamentMatch' : 'tournamentMatch';
    navigate(`/${routeBase}/${found.gameId}?tableId=${found.tableId}`);
  }
}

function handleTournamentTable({ tableId, color }) {
  const username = localStorage.getItem('username') || '';
  if (!username || !tableId) return;

  // 💡 допускаем только один вход В КАЖДЫЙ конкретный стол
  const key = `short:${tableId}`;
  if (joinedTablesRef.current.has(key)) {
    console.log('[joinTable] Уже вошли в этот стол →', tableId);
    return;
  }
  joinedTablesRef.current.add(key);

  localStorage.setItem('tableId', String(tableId));
  localStorage.setItem('gameType', 'short');

  tournamentSocket.emit('tournamentMatch_joinTable', {
    tableId: Number(tableId),
    username,
  });
  tournamentSocket.emit('fetchTournamentData', Number(tableId));

  navigate(`/tournamentMatch/${tableId}?tableId=${tableId}${color ? `&color=${color}` : ''}`);
}


// function handleTournamentTable({ tableId, color }) {
//   const username = localStorage.getItem('username') || '';
//   if (!username || !tableId) return;
//  if (alreadyJoinedTournamentRef.current) {
//     console.log('[joinTable] 🔁 Уже был вызов – пропускаем');
//     return;
//   }
//   alreadyJoinedTournamentRef.current = true;
//   localStorage.setItem('tableId', String(tableId));
//   localStorage.setItem('gameType', 'short');

//   tournamentSocket.emit('tournamentMatch_joinTable', {
//     tableId: Number(tableId),
//     username,
//   });

//   tournamentSocket.emit('fetchTournamentData', Number(tableId));

//   navigate(`/tournamentMatch/${tableId}?tableId=${tableId}&color=${color}`);
// }

const handleLongTournamentTable = ({ tableId, color }) => {
  if (!tableId) return;

  const key = `long:${tableId}`;
  if (joinedTablesRef.current.has(key)) {
    console.log('[joinLongTable] Уже вошли в этот стол →', tableId);
    return;
  }
  joinedTablesRef.current.add(key);

  localStorage.setItem('tableId', String(tableId));
  localStorage.setItem('gameType', 'long');

  navigate(`/long-tournament/table?tableId=${tableId}${color ? `&color=${color}` : ''}`);
};

longTournamentSocket.on('long_tournamentTable', handleLongTournamentTable);


    tournamentSocket.on('tournament_semifinalsStarted', handleSemifinalsStarted);

    function handleFinalStarted(data) {
      if (data.player1 === username || data.player2 === username) {
        navigate(`/tournamentMatch/${data.finalGameId}?tableId=${data.finalTableId}`);
      }
    } 
    tournamentSocket.on('tournament_table', handleTournamentTable);
    tournamentSocket.on('tournament_finalStarted', handleFinalStarted);

    return () => {
      tournamentSocket.off('tournament_semifinalsStarted', handleSemifinalsStarted);
      tournamentSocket.off('tournament_table', handleTournamentTable);
      tournamentSocket.off('tournament_finalStarted', handleFinalStarted);
       longTournamentSocket.off('long_tournamentTable', handleLongTournamentTable);
    };
  }, [username, navigate]);



useEffect(() => {
  if (!username) {
    return;
  }


  const openShortBigTournamentTable = ({
    tableId,
    color,
  } = {}) => {
    if (!tableId) {
      return;
    }


    console.log(
      '[BIG SHORT CLIENT] open table',
      tableId
    );


    localStorage.setItem(
      'bigTournamentShort:lastActiveTableId',
      String(tableId)
    );


    navigate(
      `/big-tournament/short/table?tableId=${tableId}` +
      (color ? `&color=${color}` : '')
    );
  };


  const askActiveShortTable = () => {
    bigTournamentShortSocket.emit(
      'big_getMyActiveTable',
      (response) => {
        if (response?.tableId) {
          openShortBigTournamentTable(
            response
          );
        }
      }
    );
  };


  bigTournamentShortSocket.on(
    'big_tournamentTable',
    openShortBigTournamentTable
  );


  bigTournamentShortSocket.on(
    'connect',
    askActiveShortTable
  );


  ensureBigTournamentShortSocketAuthAndConnect();


  if (
    bigTournamentShortSocket.connected
  ) {
    askActiveShortTable();
  }


  return () => {
    bigTournamentShortSocket.off(
      'big_tournamentTable',
      openShortBigTournamentTable
    );

    bigTournamentShortSocket.off(
      'connect',
      askActiveShortTable
    );
  };
}, [username, navigate]);


useEffect(() => {
  if (!username) return;

  const token =
    localStorage.getItem('token') || '';

  bigTournamentLongSocket.auth = {
    token,
    username,
  };


  const openBigTournamentTable = ({
    tableId,
    color,
  } = {}) => {
    if (!tableId) return;

    console.log(
      '[BIG TOURNAMENT CLIENT] open table',
      tableId
    );

    localStorage.setItem(
      'bigTournament:lastActiveTableId',
      String(tableId)
    );

    navigate(
      `/big-tournament/table?tableId=${tableId}` +
      (color ? `&color=${color}` : '')
    );
  };


  const askActiveBigTournamentTable = () => {
    bigTournamentLongSocket.emit(
      'big_getMyActiveTable',
      (resp) => {
        if (resp?.tableId) {
          openBigTournamentTable(resp);
        }
      }
    );
  };

const activeTablePoll = setInterval(() => {
  if (!bigTournamentLongSocket.connected) {
    return;
  }

  bigTournamentLongSocket.emit(
    'big_getMyActiveTable',
    (resp) => {
      if (resp?.tableId) {
        openBigTournamentTable(resp);
      }
    }
  );
}, 2000);


  bigTournamentLongSocket.on(
    'big_tournamentTable',
    openBigTournamentTable
  );


  bigTournamentLongSocket.on(
    'connect',
    askActiveBigTournamentTable
  );


  if (bigTournamentLongSocket.connected) {
    askActiveBigTournamentTable();
  } else {
    bigTournamentLongSocket.connect();
  }


  return () => {
    clearInterval(activeTablePoll);

    bigTournamentLongSocket.off(
      'big_tournamentTable',
      openBigTournamentTable
    );

    bigTournamentLongSocket.off(
      'connect',
      askActiveBigTournamentTable
    );
  };
}, [username, navigate]);



  const handleLogin = (newToken, newUsername, newRole) => {
  
    
    setToken(newToken);
    setUsername(newUsername);
    setRole(newRole);  // <-- Сохраняем роль
    localStorage.setItem('token', newToken);
    localStorage.setItem('username', newUsername);
    localStorage.setItem('role', newRole); // <-- в localStorage
  };





  useEffect(() => {
  const token = localStorage.getItem('token');
  if (!token) return;

  axios
  .get(`${API_BASE}/user/assets`, {
    headers: { Authorization: `Bearer ${token}` }
  })

    .then(res => {
      setUserAssets(res.data);
      console.log('[App] Первичная загрузка userAssets:', res.data);
    })
    .catch(err => {
      console.error('[App] Ошибка при загрузке userAssets:', err);
    });
}, []);



useEffect(() => {
  // --- BALANCE (socket) ---
  // const onMainBalance = ({ balance }) => {
  //   console.log('[userBalance][main] <-', balance);
  //   lastBalanceUpdateRef.current = { ts: Date.now(), src: 'main' };
  //   setUserBalance(balance);
  // };
  const onMainBalance = ({ balance }) => {
  const next = Number(balance);
  setUserBalance(prev => {
    const prevNum = Number(prev ?? 0);
    if (!Number.isFinite(next)) return prev; // мусор игнорим
    if (prev != null && next < prevNum) {
      console.log('[userBalance][main] ignored lower', next, '<', prevNum);
      return prev; // не занижаем свежий баланс
    }
    console.log('[userBalance][main] <-', next);
    lastBalanceUpdateRef.current = { ts: Date.now(), src: 'main' };
    return next;
  });
};

  const onTournamentBalance = ({ balance }) => {
    const now = Date.now();
    const last = lastBalanceUpdateRef.current;
    // если только что пришёл пуш с основного сокета — не затираем его старым
    if (last.src === 'main' && now - last.ts < 3000) {
      console.log('[userBalance][tournament] ignored (prefer main, 3s window)', balance);
      return;
    }
    console.log('[userBalance][tournament] <-', balance);
    lastBalanceUpdateRef.current = { ts: now, src: 'tournament' };
    setUserBalance(balance);
  };

  // --- ASSETS (как было) ---
  const handleUserAssets = ({ tickets, skins }) => {
    setUserAssets(prev => ({
      ...prev,
      tickets: tickets ?? prev.tickets,
      skins: Array.isArray(skins)
        ? skins
        : (typeof skins === 'number'
            ? [{ skin_type: 'common', quantity: skins }]
            : prev.skins)
    }));
  };

  // Подписки
  socket.on('userBalance', onMainBalance);
  // tournamentSocket.on('userBalance', onTournamentBalance);

  socket.on('userAssets', handleUserAssets);
  tournamentSocket.on('userAssets', handleUserAssets);

  return () => {
    socket.off('userBalance', onMainBalance);
    tournamentSocket.off('userBalance', onTournamentBalance);

    socket.off('userAssets', handleUserAssets);
    tournamentSocket.off('userAssets', handleUserAssets);
  };
}, []);

// useEffect(() => {
//   function handleUserBalance({ balance }) {
//     console.log('[userBalance] Новый баланс:', balance);
//     setUserBalance(balance);
//   }

//   // function handleUserAssets({ tickets, skins }) {
//   //   console.log('[userAssets] Обновление:', tickets, skins);
//   //   setUserAssets(prev => ({
//   //     ...prev,
//   //     tickets: tickets ?? prev.tickets,
//   //     skins: skins ?? prev.skins
//   //   }));
//   // }
// function handleUserAssets({ tickets, skins }) {
//   setUserAssets(prev => ({
//     ...prev,
//     tickets: tickets ?? prev.tickets,
//     // принимаем и массив, и число
//     skins: Array.isArray(skins)
//       ? skins
//       : (typeof skins === 'number'
//            ? [{ skin_type: 'common', quantity: skins }]
//            : prev.skins)
//   }));
// }

//   // Слушаем с двух сокетов
//   socket.on('userBalance', handleUserBalance);
//   tournamentSocket.on('userBalance', handleUserBalance);

//   socket.on('userAssets', handleUserAssets);
//   tournamentSocket.on('userAssets', handleUserAssets);

//   return () => {
//     socket.off('userBalance', handleUserBalance);
//     tournamentSocket.off('userBalance', handleUserBalance);

//     socket.off('userAssets', handleUserAssets);
//     tournamentSocket.off('userAssets', handleUserAssets);
//   };
// }, []);


  // useEffect(() => {
  //   socket.on("userBalance", ({ balance }) => {
     
  //     setUserBalance(balance);
  //   });
  //   return () => socket.off("userBalance");
  // }, []);
  // Восстанавливаем токен, юзер, роль
  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUsername = localStorage.getItem('username');
    const savedRole = localStorage.getItem('role'); // <-- Читаем из localStorage
    if (savedToken) {
      setToken(savedToken);
      setUsername(savedUsername);
      setRole(savedRole || '');
          // <-- ТУТ. Вызываем запрос баланса, если есть username
    if (savedUsername) {
      
      
      socket.emit('getUserBalance', { username: savedUsername });
    }
    }
  }, []);

  // 5) socket.io (обычный)
  // useEffect(() => {
  //   socket.connect();
  //   socket.on('connect', () => {
  
  //   });
  //   return () => {
  //     socket.off('connect');
  //   };
  // }, []);
useEffect(() => {
  const token = localStorage.getItem('token');
  if (token) {
    socket.auth = { token }; // ✅ ПЕРЕДАЁМ token

    if (!token) {
  socket.auth = { guest: true };
}
  }

  socket.connect();

  socket.on('connect', () => {
    console.log('[socket.io] connected');
    if (usernameRef.current) {
  socket.emit('joinUserRoom', { username: usernameRef.current });
  console.log('[socket.io] joinUserRoom sent for', usernameRef.current);
}

  });

  return () => {
    socket.off('connect');
  };
}, []);











useEffect(() => {
  const onStorage = (e) => {
    // срабатывает в ДРУГОЙ вкладке, когда ТАМ изменили localStorage
    if (e.key === 'auth:bump') {
      console.log('[auth] another tab logged in -> force logout here');

      // чистим авторизацию
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('role');

      // по желанию: отключить сокеты, чтобы сразу отрубилось всё
      try { socket.disconnect(); } catch {}
      try { longSocket.disconnect(); } catch {}
      try { tournamentSocket.disconnect(); } catch {}
      try { longTournamentSocket.disconnect(); } catch {}

      // мгновенный редирект
      window.location.href = '/login';
    }
  };

  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
}, []);




useEffect(() => {
  if (username && socket.connected) {
    socket.emit('joinUserRoom', { username });
    console.log('[socket.io] joinUserRoom (username change):', username);
  }
}, [username]);





// ловим моментальное обновление активов (из /collect через window event)
useEffect(() => {
  const onAssets = (e) => {
    const { tickets, skins } = e.detail || {};
    setUserAssets(prev => ({
      ...prev,
      tickets: tickets ?? prev.tickets,
      skins:   skins   ?? prev.skins,
    }));
  };
  window.addEventListener('assets-updated', onAssets);
  return () => window.removeEventListener('assets-updated', onAssets);
}, []);

// ловим моментальное обновление денег
// useEffect(() => {
//   const onBalance = (e) => {
//     const next = e.detail?.balance;
//     if (typeof next === 'number') setUserBalance(next);
//   };
//   window.addEventListener('balance-updated', onBalance);
//   return () => window.removeEventListener('balance-updated', onBalance);
// }, []);



useEffect(() => {
  const onBalance = (e) => {
    const d = e.detail || {};

    // delta-режим (всегда применяем)
    if (typeof d.add === 'number') {
      console.log('[balance-updated][delta] +', d.add);
      lastBalanceUpdateRef.current = { ts: Date.now(), src: 'delta' };
      setUserBalance(prev => Number(prev || 0) + Number(d.add));
      return;
    }

    // абсолютное значение — не занижаем, если явного разрешения нет
    if (typeof d.balance === 'number') {
      const src = d.source || 'window';
      const allowDecrease = !!d.allowDecrease; // по умолчанию запрещено
      setUserBalance(prev => {
        const next = Number(d.balance);
        if (!allowDecrease && prev != null && next < prev) {
          console.log(`[balance-updated][${src}] ignored lower absolute`, next, '<', prev);
          return prev;
        }
        console.log(`[balance-updated][${src}] set`, next);
        lastBalanceUpdateRef.current = { ts: Date.now(), src };
        return next;
      });
    }
  };

  window.addEventListener('balance-updated', onBalance);
  return () => window.removeEventListener('balance-updated', onBalance);
}, []);


//   useEffect(() => {
//   const onBalance = (e) => {
//     const d = e.detail || {};
//     if (typeof d.balance === 'number') {
//       setUserBalance(d.balance);             // абсолютное значение
//     } else if (typeof d.add === 'number') {
//       setUserBalance(prev => Number(prev || 0) + d.add); // поддержка delta
//     }
//   };
//   window.addEventListener('balance-updated', onBalance);
//   return () => window.removeEventListener('balance-updated', onBalance);
// }, []);


  // tableUpdated
  useEffect(() => {
    socket.on('tableUpdated', (updatedTable) => {
      setTables((prevTables) =>
        prevTables.map((table) =>
          table.id === updatedTable.id ? updatedTable : table
        )
      );
    });
    return () => {
      socket.off('tableUpdated');
    };
  }, [setTables]);







  function LongBackgammonWrapper() {
  const { gameId } = useParams();
  const query = new URLSearchParams(useLocation().search);
  const tableId = query.get('tableId');

  return (
    <LongBackgammon
      socket={tournamentSocket}
      isTournament
      tableId={Number(tableId)}
      gameId={Number(gameId)}
    />
  );
}


  return (
    <>
      <PresenceHeartbeat token={token} />
      <SpinWheelOverlay show={showWheel} angle={wheelAngle} onHide={() => setShowWheel(false)} />
      <SiteBannerPopup />
      <Routes>
  {/* Публичные роуты (без шапки) */}
  <Route
    path="/login"
    element={<Login onLogin={handleLogin} userBalance={userBalance} setUserBalance={setUserBalance} />}
  />
  <Route path="/register" element={<Register />} />

  {/* Роуты столов (кеш/турнир) – тоже без шапки */}
  <Route path="/game/:tableId" element={<Game token={token} />} />
  <Route path="/tournamentMatch/:gameId" element={<TournamentMatch />} />

  <Route path="/longGame/:tableId" element={<LongBackgammon socket={longSocket} />} /> 
  <Route path="/khachapuriGame/:tableId" element={<Khachapuri />} />
   {/* <Route
  path="/longTournamentMatch/:gameId"
  element={<LongBackgammon socket={tournamentSocket} isTournament />}
></Route> */}
<Route path="/longTournamentMatch/:gameId" element={<LongTournamentBackgammon />} />
 <Route
  path="/long-tournament/table"
  element={<LongTournamentBackgammon />}
/>

<Route
  path="/big-tournament/table"
  element={<BigTournamentBackgammon />}
/>

<Route
  path="/big-tournament/short/table"
  element={<BigTournamentShortMatch />}
/>

  <Route path="/ShortBackgammonBoard/:tableId" element={<ShortBackgammonBoard />} />

 {/* <Route path="/poker/table/:tableId" element={<PokerTable />} /> */}
<Route path="/poker/table/:tableId" element={<PokerTable userAvatar={userAvatar} />} />

  {/* Все остальные роуты под общим макетом Layout (с Header) */}
  <Route
    element={
      <Layout
        username={username}
        userBalance={userBalance}
        onLogout={handleLogout}
        userAvatar={userAvatar}
        userAssets={userAssets}
      />
    }
  >

    <Route path="/forgot-password" element={<ForgotPassword />} />

    <Route
      path="/"
      element={
        <Lobby
          token={token}
          username={username}
          userBalance={userBalance}
          setUserBalance={setUserBalance}
        />
      }
    />
   
   <Route
  path="/profile/*"
  element={
    <ProfileLayout
      username={username}
      userAssets={userAssets}          // 👈 нужно для вкладок
      userBalance={userBalance}
      setUsername={setUsername}
    />
  }
/>
 
    {/* <Route
      path="/tournamentsPage"
      element={<TournamentsPage token={token} username={username} />}
    /> */}
      {/* <Route
      path="/tournaments"
      element={<TournamentsPage token={token} username={username} />}
    /> */}
    <Route
   path="/tournaments"
   element={<Navigate to="/?gt=long" replace />}
 />
    <Route
    path="/quests"
    element={<Quests />}
  />
    <Route path="/admin" element={<AdminPanel role={role} />} />
    <Route path="/poker" element={<PokerLobby />} />

    <Route path="/satellites" element={<SatellitesPage />} />
    <Route path="/satellites/:id" element={<SatelliteDetails />} />

    <Route
      path="/big-tournaments"
      element={<BigTournamentsPage />}
    />

    <Route path="/draws" element={<DrawBracketsHome />} />
    <Route path="/draws/:id" element={<DrawBracketsDetail />} />

    <Route
      path="/big-tournaments/:id"
      element={<BigTournamentDetails />}
    />

    {/* Любой несуществующий адрес */}
  <Route
    path="*"
    element={
      localStorage.getItem("token") ? (
        <Navigate to="/" replace />
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />
  </Route>
</Routes>
    </>
  );
};

export const App = () => {
  return (
    <GameProvider>
      <PokerProvider>
        <SoundProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </SoundProvider>
      </PokerProvider>
    </GameProvider>
  );
};

export default App;






// import React, { useState, useEffect,useRef } from 'react';
// import {
//   BrowserRouter,
//   Route,
//   Routes,
//   useNavigate,
//   useParams,
//   useLocation,
//   Navigate
// } from 'react-router-dom';


// // Локальные импорты
// import { useGame, GameProvider } from './context/GameContext'; 
// import socket from './socket';
// import axios from 'axios';
// import tournamentSocket from './tournamentSocket';
// import longSocket from './longSocket';
// import Khachapuri from './Khachapuri';
// import SpinWheelOverlay from './SpinWheelOverlay';
// import Login from './Login';
// import Register from './Register';
// import Lobby from './Lobby';
// import Game from './Game';
// import TournamentsPage from './TournamentsPage';
// import TournamentMatch from './TournamentMatch';
// import LongBackgammon from './LongBackgammon';
// import ShortBackgammonBoard from './ShortBackgammonBoard';
// import AdminPanel from './AdminPanel';
// import Layout from './Layout'; // <-- наш общий макет
// import Profile from './Profile';

// import SiteBannerPopup
//   from './components/SiteBannerPopup';
// import PresenceHeartbeat
//   from './components/PresenceHeartbeat';

// import LongTournamentBackgammon from './LongTournamentBackgammon';
// import { useTournamentSocket } from './hooks/useTournamentSocket';
// import longTournamentSocket, { ensureLongSocket } from './longTournamentSocket';

// import BigTournamentBackgammon
//   from './BigTournamentBackgammon';


//   import BigTournamentShortMatch
//   from './BigTournamentShortMatch';


// import bigTournamentLongSocket
//   from './bigTournamentLongSocket';

// import bigTournamentShortSocket, {
//   ensureBigTournamentShortSocketAuthAndConnect,
// } from './bigTournamentShortSocket';

// import Quests from './components/Quests';
// import { SoundProvider } from './sfx/SoundProvider'; // ← твой путь
// import ProfileLayout from './ProfileLayout';
// import { PokerProvider } from './poker/context/PokerContext';
// import PokerLobby from './poker/PokerLobby';
// import PokerTable from './poker/PokerTable';
// import ForgotPassword from './ForgotPassword';



// import SatellitesPage from './satellites/SatellitesPage';
// import SatelliteDetails from './satellites/SatelliteDetails';

// import BigTournamentsPage
//   from './bigTournaments/BigTournamentsPage';

//   import BigTournamentDetails
//   from './bigTournaments/BigTournamentDetails';
// // import Header from './Header'; // если захотите напрямую 

// const AppContent = () => {
//   const [token, setToken] = useState(null);
//   const [username, setUsername] = useState('');
//   const [role, setRole] = useState('');  // <-- Добавили
  

//   const [showWheel, setShowWheel] = useState(false);
//   const [wheelAngle, setWheelAngle] = useState(0);
//   const [userAvatar, setUserAvatar] = useState('');
//   const [userBalance, setUserBalance] = useState(null); 
//   const [userAssets, setUserAssets] = useState({ tickets: [], skins: [] });

//   const { tables, setTables } = useGame();
//   const navigate = useNavigate();
//  const tournamentSocket = useTournamentSocket()
// const lastBalanceUpdateRef = useRef({ ts: 0, src: 'init' });


//  const API_ORIGIN = process.env.REACT_APP_API_URL;   // например: http://147.93.123.26:5000
// const API_BASE   = `${API_ORIGIN}/api`;


// //  const alreadyJoinedTournamentRef = useRef(false);
// const joinedTablesRef = useRef(new Set());

// const usernameRef = useRef('');
// useEffect(() => {
//   usernameRef.current = username;
// }, [username]);



// const handleLogout = () => {
//   localStorage.removeItem('token');
//   localStorage.removeItem('username');
//   localStorage.removeItem('role');

//   localStorage.removeItem(
//     'bigTournament:lastActiveTableId'
//   );

//   sessionStorage.removeItem(
//     'bigTournament:lastActiveTableId'
//   );

//   window.location.href = '/';
// };
 





//   useEffect(() => {
//   const token = localStorage.getItem('token') || '';
//   const username = localStorage.getItem('username') || '';

//   // выставляем оба поля, чтобы бэку было и кто, и с каким токеном
//   try {
//     longTournamentSocket.auth = { token, username };
//   } catch {}

//   // гарантированный коннект
//   if (!longTournamentSocket.connected && !longTournamentSocket.connecting) {
//     longTournamentSocket.connect();
//   }
// }, []);





// useEffect(() => {
//   const ask = () => {
//     longTournamentSocket.emit('long_getMyActiveTable', (resp) => {
//       if (resp?.tableId) {
//         navigate(`/long-tournament/table?tableId=${resp.tableId}`);
//       }
//     });
//   };

//   if (longTournamentSocket.connected) {
//     ask();               // если уже подключены – спросить сразу
//   }
//   longTournamentSocket.on('connect', ask); // и на каждый последующий connect

//   return () => {
//     longTournamentSocket.off('connect', ask);
//   };
// }, [navigate]);




//   useEffect(() => {
//     longSocket.connect();
//     return () => {
//       longSocket.disconnect();
//     };
//   }, []);



// // useEffect(() => {
// //   const token = localStorage.getItem('token');
// //   if (!token) return;

// //   try {
// //     socket.auth = { token };
// //     longSocket.auth = { token };
// //     tournamentSocket.auth = { token };
// //     // longTournamentSocket.auth = { token };
// //     longTournamentSocket.auth = { token, username: localStorage.getItem('username') || '' };
// //   } catch {}

// //   if (!socket.connected && !socket.connecting) socket.connect();
// //   if (!longSocket.connected && !longSocket.connecting) longSocket.connect();
// //   if (!tournamentSocket.connected && !tournamentSocket.connecting) tournamentSocket.connect();
// //   if (!longTournamentSocket.connected && !longTournamentSocket.connecting) longTournamentSocket.connect();
// // }, []);
// useEffect(() => {
//   const token = localStorage.getItem('token');
//   const username = localStorage.getItem('username') || '';
//   if (!token) return;

//   try {
//     socket.auth = { token };
//     longSocket.auth = { token };

//     // ⛔ БОЛЬШЕ НЕ ТРОГАЕМ tournamentSocket ЗДЕСЬ
//     // tournamentSocket.auth = { token };

//     // longTournamentSocket.auth = { token };
//     longTournamentSocket.auth = { token, username };
//   } catch {}

//   if (!socket.connected && !socket.connecting) socket.connect();
//   if (!longSocket.connected && !longSocket.connecting) longSocket.connect();

//   // ⛔ И КОННЕКТ ТУРНИРНОГО СОКЕТА ТОЖЕ УБИРАЕМ
//   // if (!tournamentSocket.connected && !tournamentSocket.connecting) {
//   //   tournamentSocket.connect();
//   // }

//   if (!longTournamentSocket.connected && !longTournamentSocket.connecting) {
//     longTournamentSocket.connect();
//   }
// }, []); // зависимости можно оставить пустые, как и было



// socket.on('forceReload', (payload) => {
//   console.log('[SIO] forceReload', payload);
//   window.location.reload();
// });



// useEffect(() => {
//   const onForceLogout = (payload) => {
//     console.log('[auth] forceLogout from server', payload);

//     // ВАЖНО: не трогаем localStorage, иначе выкинет и вторую вкладку тоже
//     // Просто "убиваем" соединения и уводим на логин

//     try { socket.disconnect(); } catch (e) {}
//     try { longSocket.disconnect(); } catch (e) {}
//     try { tournamentSocket.disconnect(); } catch (e) {}
//     // если есть еще сокеты — тоже отключи

//     // Увести на страницу авторизации
//     window.location.replace('/login');
//   };

//   socket.on('forceLogout', onForceLogout);

//   return () => {
//     socket.off('forceLogout', onForceLogout);
//   };
// }, []);



//   useEffect(() => {
//     const savedToken = localStorage.getItem('token');
//     const savedUsername = localStorage.getItem('username');
//     const savedRole = localStorage.getItem('role');
  
//     if (savedToken) {
//       setToken(savedToken);
//       setUsername(savedUsername);
//       setRole(savedRole || '');
  
//       if (savedUsername) {
//         socket.emit('getUserBalance', { username: savedUsername });
//       }
  
//       // ⬇️ ВСТАВЬ ЗДЕСЬ
//       axios.get(`${API_BASE}/profile`, {
//       headers: { Authorization: `Bearer ${savedToken}` }
//     })

//       .then(res => {
//         setUserAvatar(res.data.avatar); // 👈 сохраняем путь к аватарке
//       })
//       .catch(err => {
//         console.error('Ошибка при получении профиля:', err);
//       });
//     }
//   }, []);




//   // 2) полуфинал/финал
//   useEffect(() => {
//     if (!username) return;
//  function handleSemifinalsStarted({ tournamentId, gameType, semifinalTables }) {
//   // const found = semifinalTables.find(
//   //   (pair) => pair.player1 === username || pair.player2 === username
//   // );
//   const found = semifinalTables.find(m =>
//   [m.player1, m.player2, m.player1Name, m.player2Name].includes(username)
// );

//   if (found) {
//     const routeBase = gameType === 'long' ? 'longTournamentMatch' : 'tournamentMatch';
//     navigate(`/${routeBase}/${found.gameId}?tableId=${found.tableId}`);
//   }
// }

// function handleTournamentTable({ tableId, color }) {
//   const username = localStorage.getItem('username') || '';
//   if (!username || !tableId) return;

//   // 💡 допускаем только один вход В КАЖДЫЙ конкретный стол
//   const key = `short:${tableId}`;
//   if (joinedTablesRef.current.has(key)) {
//     console.log('[joinTable] Уже вошли в этот стол →', tableId);
//     return;
//   }
//   joinedTablesRef.current.add(key);

//   localStorage.setItem('tableId', String(tableId));
//   localStorage.setItem('gameType', 'short');

//   tournamentSocket.emit('tournamentMatch_joinTable', {
//     tableId: Number(tableId),
//     username,
//   });
//   tournamentSocket.emit('fetchTournamentData', Number(tableId));

//   navigate(`/tournamentMatch/${tableId}?tableId=${tableId}${color ? `&color=${color}` : ''}`);
// }


// // function handleTournamentTable({ tableId, color }) {
// //   const username = localStorage.getItem('username') || '';
// //   if (!username || !tableId) return;
// //  if (alreadyJoinedTournamentRef.current) {
// //     console.log('[joinTable] 🔁 Уже был вызов – пропускаем');
// //     return;
// //   }
// //   alreadyJoinedTournamentRef.current = true;
// //   localStorage.setItem('tableId', String(tableId));
// //   localStorage.setItem('gameType', 'short');

// //   tournamentSocket.emit('tournamentMatch_joinTable', {
// //     tableId: Number(tableId),
// //     username,
// //   });

// //   tournamentSocket.emit('fetchTournamentData', Number(tableId));

// //   navigate(`/tournamentMatch/${tableId}?tableId=${tableId}&color=${color}`);
// // }

// const handleLongTournamentTable = ({ tableId, color }) => {
//   if (!tableId) return;

//   const key = `long:${tableId}`;
//   if (joinedTablesRef.current.has(key)) {
//     console.log('[joinLongTable] Уже вошли в этот стол →', tableId);
//     return;
//   }
//   joinedTablesRef.current.add(key);

//   localStorage.setItem('tableId', String(tableId));
//   localStorage.setItem('gameType', 'long');

//   navigate(`/long-tournament/table?tableId=${tableId}${color ? `&color=${color}` : ''}`);
// };

// longTournamentSocket.on('long_tournamentTable', handleLongTournamentTable);


//     tournamentSocket.on('tournament_semifinalsStarted', handleSemifinalsStarted);

//     function handleFinalStarted(data) {
//       if (data.player1 === username || data.player2 === username) {
//         navigate(`/tournamentMatch/${data.finalGameId}?tableId=${data.finalTableId}`);
//       }
//     } 
//     tournamentSocket.on('tournament_table', handleTournamentTable);
//     tournamentSocket.on('tournament_finalStarted', handleFinalStarted);

//     return () => {
//       tournamentSocket.off('tournament_semifinalsStarted', handleSemifinalsStarted);
//       tournamentSocket.off('tournament_table', handleTournamentTable);
//       tournamentSocket.off('tournament_finalStarted', handleFinalStarted);
//        longTournamentSocket.off('long_tournamentTable', handleLongTournamentTable);
//     };
//   }, [username, navigate]);



// useEffect(() => {
//   if (!username) {
//     return;
//   }


//   const openShortBigTournamentTable = ({
//     tableId,
//     color,
//   } = {}) => {
//     if (!tableId) {
//       return;
//     }


//     console.log(
//       '[BIG SHORT CLIENT] open table',
//       tableId
//     );


//     localStorage.setItem(
//       'bigTournamentShort:lastActiveTableId',
//       String(tableId)
//     );


//     navigate(
//       `/big-tournament/short/table?tableId=${tableId}` +
//       (color ? `&color=${color}` : '')
//     );
//   };


//   const askActiveShortTable = () => {
//     bigTournamentShortSocket.emit(
//       'big_getMyActiveTable',
//       (response) => {
//         if (response?.tableId) {
//           openShortBigTournamentTable(
//             response
//           );
//         }
//       }
//     );
//   };


//   bigTournamentShortSocket.on(
//     'big_tournamentTable',
//     openShortBigTournamentTable
//   );


//   bigTournamentShortSocket.on(
//     'connect',
//     askActiveShortTable
//   );


//   ensureBigTournamentShortSocketAuthAndConnect();


//   if (
//     bigTournamentShortSocket.connected
//   ) {
//     askActiveShortTable();
//   }


//   return () => {
//     bigTournamentShortSocket.off(
//       'big_tournamentTable',
//       openShortBigTournamentTable
//     );

//     bigTournamentShortSocket.off(
//       'connect',
//       askActiveShortTable
//     );
//   };
// }, [username, navigate]);


// useEffect(() => {
//   if (!username) return;

//   const token =
//     localStorage.getItem('token') || '';

//   bigTournamentLongSocket.auth = {
//     token,
//     username,
//   };


//   const openBigTournamentTable = ({
//     tableId,
//     color,
//   } = {}) => {
//     if (!tableId) return;

//     console.log(
//       '[BIG TOURNAMENT CLIENT] open table',
//       tableId
//     );

//     localStorage.setItem(
//       'bigTournament:lastActiveTableId',
//       String(tableId)
//     );

//     navigate(
//       `/big-tournament/table?tableId=${tableId}` +
//       (color ? `&color=${color}` : '')
//     );
//   };


//   const askActiveBigTournamentTable = () => {
//     bigTournamentLongSocket.emit(
//       'big_getMyActiveTable',
//       (resp) => {
//         if (resp?.tableId) {
//           openBigTournamentTable(resp);
//         }
//       }
//     );
//   };

// const activeTablePoll = setInterval(() => {
//   if (!bigTournamentLongSocket.connected) {
//     return;
//   }

//   bigTournamentLongSocket.emit(
//     'big_getMyActiveTable',
//     (resp) => {
//       if (resp?.tableId) {
//         openBigTournamentTable(resp);
//       }
//     }
//   );
// }, 2000);


//   bigTournamentLongSocket.on(
//     'big_tournamentTable',
//     openBigTournamentTable
//   );


//   bigTournamentLongSocket.on(
//     'connect',
//     askActiveBigTournamentTable
//   );


//   if (bigTournamentLongSocket.connected) {
//     askActiveBigTournamentTable();
//   } else {
//     bigTournamentLongSocket.connect();
//   }


//   return () => {
//     clearInterval(activeTablePoll);

//     bigTournamentLongSocket.off(
//       'big_tournamentTable',
//       openBigTournamentTable
//     );

//     bigTournamentLongSocket.off(
//       'connect',
//       askActiveBigTournamentTable
//     );
//   };
// }, [username, navigate]);



//   const handleLogin = (newToken, newUsername, newRole) => {
  
    
//     setToken(newToken);
//     setUsername(newUsername);
//     setRole(newRole);  // <-- Сохраняем роль
//     localStorage.setItem('token', newToken);
//     localStorage.setItem('username', newUsername);
//     localStorage.setItem('role', newRole); // <-- в localStorage
//   };





//   useEffect(() => {
//   const token = localStorage.getItem('token');
//   if (!token) return;

//   axios
//   .get(`${API_BASE}/user/assets`, {
//     headers: { Authorization: `Bearer ${token}` }
//   })

//     .then(res => {
//       setUserAssets(res.data);
//       console.log('[App] Первичная загрузка userAssets:', res.data);
//     })
//     .catch(err => {
//       console.error('[App] Ошибка при загрузке userAssets:', err);
//     });
// }, []);



// useEffect(() => {
//   // --- BALANCE (socket) ---
//   // const onMainBalance = ({ balance }) => {
//   //   console.log('[userBalance][main] <-', balance);
//   //   lastBalanceUpdateRef.current = { ts: Date.now(), src: 'main' };
//   //   setUserBalance(balance);
//   // };
//   const onMainBalance = ({ balance }) => {
//   const next = Number(balance);
//   setUserBalance(prev => {
//     const prevNum = Number(prev ?? 0);
//     if (!Number.isFinite(next)) return prev; // мусор игнорим
//     if (prev != null && next < prevNum) {
//       console.log('[userBalance][main] ignored lower', next, '<', prevNum);
//       return prev; // не занижаем свежий баланс
//     }
//     console.log('[userBalance][main] <-', next);
//     lastBalanceUpdateRef.current = { ts: Date.now(), src: 'main' };
//     return next;
//   });
// };

//   const onTournamentBalance = ({ balance }) => {
//     const now = Date.now();
//     const last = lastBalanceUpdateRef.current;
//     // если только что пришёл пуш с основного сокета — не затираем его старым
//     if (last.src === 'main' && now - last.ts < 3000) {
//       console.log('[userBalance][tournament] ignored (prefer main, 3s window)', balance);
//       return;
//     }
//     console.log('[userBalance][tournament] <-', balance);
//     lastBalanceUpdateRef.current = { ts: now, src: 'tournament' };
//     setUserBalance(balance);
//   };

//   // --- ASSETS (как было) ---
//   const handleUserAssets = ({ tickets, skins }) => {
//     setUserAssets(prev => ({
//       ...prev,
//       tickets: tickets ?? prev.tickets,
//       skins: Array.isArray(skins)
//         ? skins
//         : (typeof skins === 'number'
//             ? [{ skin_type: 'common', quantity: skins }]
//             : prev.skins)
//     }));
//   };

//   // Подписки
//   socket.on('userBalance', onMainBalance);
//   // tournamentSocket.on('userBalance', onTournamentBalance);

//   socket.on('userAssets', handleUserAssets);
//   tournamentSocket.on('userAssets', handleUserAssets);

//   return () => {
//     socket.off('userBalance', onMainBalance);
//     tournamentSocket.off('userBalance', onTournamentBalance);

//     socket.off('userAssets', handleUserAssets);
//     tournamentSocket.off('userAssets', handleUserAssets);
//   };
// }, []);

// // useEffect(() => {
// //   function handleUserBalance({ balance }) {
// //     console.log('[userBalance] Новый баланс:', balance);
// //     setUserBalance(balance);
// //   }

// //   // function handleUserAssets({ tickets, skins }) {
// //   //   console.log('[userAssets] Обновление:', tickets, skins);
// //   //   setUserAssets(prev => ({
// //   //     ...prev,
// //   //     tickets: tickets ?? prev.tickets,
// //   //     skins: skins ?? prev.skins
// //   //   }));
// //   // }
// // function handleUserAssets({ tickets, skins }) {
// //   setUserAssets(prev => ({
// //     ...prev,
// //     tickets: tickets ?? prev.tickets,
// //     // принимаем и массив, и число
// //     skins: Array.isArray(skins)
// //       ? skins
// //       : (typeof skins === 'number'
// //            ? [{ skin_type: 'common', quantity: skins }]
// //            : prev.skins)
// //   }));
// // }

// //   // Слушаем с двух сокетов
// //   socket.on('userBalance', handleUserBalance);
// //   tournamentSocket.on('userBalance', handleUserBalance);

// //   socket.on('userAssets', handleUserAssets);
// //   tournamentSocket.on('userAssets', handleUserAssets);

// //   return () => {
// //     socket.off('userBalance', handleUserBalance);
// //     tournamentSocket.off('userBalance', handleUserBalance);

// //     socket.off('userAssets', handleUserAssets);
// //     tournamentSocket.off('userAssets', handleUserAssets);
// //   };
// // }, []);


//   // useEffect(() => {
//   //   socket.on("userBalance", ({ balance }) => {
     
//   //     setUserBalance(balance);
//   //   });
//   //   return () => socket.off("userBalance");
//   // }, []);
//   // Восстанавливаем токен, юзер, роль
//   useEffect(() => {
//     const savedToken = localStorage.getItem('token');
//     const savedUsername = localStorage.getItem('username');
//     const savedRole = localStorage.getItem('role'); // <-- Читаем из localStorage
//     if (savedToken) {
//       setToken(savedToken);
//       setUsername(savedUsername);
//       setRole(savedRole || '');
//           // <-- ТУТ. Вызываем запрос баланса, если есть username
//     if (savedUsername) {
      
      
//       socket.emit('getUserBalance', { username: savedUsername });
//     }
//     }
//   }, []);

//   // 5) socket.io (обычный)
//   // useEffect(() => {
//   //   socket.connect();
//   //   socket.on('connect', () => {
  
//   //   });
//   //   return () => {
//   //     socket.off('connect');
//   //   };
//   // }, []);
// useEffect(() => {
//   const token = localStorage.getItem('token');
//   if (token) {
//     socket.auth = { token }; // ✅ ПЕРЕДАЁМ token

//     if (!token) {
//   socket.auth = { guest: true };
// }
//   }

//   socket.connect();

//   socket.on('connect', () => {
//     console.log('[socket.io] connected');
//     if (usernameRef.current) {
//   socket.emit('joinUserRoom', { username: usernameRef.current });
//   console.log('[socket.io] joinUserRoom sent for', usernameRef.current);
// }

//   });

//   return () => {
//     socket.off('connect');
//   };
// }, []);











// useEffect(() => {
//   const onStorage = (e) => {
//     // срабатывает в ДРУГОЙ вкладке, когда ТАМ изменили localStorage
//     if (e.key === 'auth:bump') {
//       console.log('[auth] another tab logged in -> force logout here');

//       // чистим авторизацию
//       localStorage.removeItem('token');
//       localStorage.removeItem('username');
//       localStorage.removeItem('role');

//       // по желанию: отключить сокеты, чтобы сразу отрубилось всё
//       try { socket.disconnect(); } catch {}
//       try { longSocket.disconnect(); } catch {}
//       try { tournamentSocket.disconnect(); } catch {}
//       try { longTournamentSocket.disconnect(); } catch {}

//       // мгновенный редирект
//       window.location.href = '/login';
//     }
//   };

//   window.addEventListener('storage', onStorage);
//   return () => window.removeEventListener('storage', onStorage);
// }, []);




// useEffect(() => {
//   if (username && socket.connected) {
//     socket.emit('joinUserRoom', { username });
//     console.log('[socket.io] joinUserRoom (username change):', username);
//   }
// }, [username]);





// // ловим моментальное обновление активов (из /collect через window event)
// useEffect(() => {
//   const onAssets = (e) => {
//     const { tickets, skins } = e.detail || {};
//     setUserAssets(prev => ({
//       ...prev,
//       tickets: tickets ?? prev.tickets,
//       skins:   skins   ?? prev.skins,
//     }));
//   };
//   window.addEventListener('assets-updated', onAssets);
//   return () => window.removeEventListener('assets-updated', onAssets);
// }, []);

// // ловим моментальное обновление денег
// // useEffect(() => {
// //   const onBalance = (e) => {
// //     const next = e.detail?.balance;
// //     if (typeof next === 'number') setUserBalance(next);
// //   };
// //   window.addEventListener('balance-updated', onBalance);
// //   return () => window.removeEventListener('balance-updated', onBalance);
// // }, []);



// useEffect(() => {
//   const onBalance = (e) => {
//     const d = e.detail || {};

//     // delta-режим (всегда применяем)
//     if (typeof d.add === 'number') {
//       console.log('[balance-updated][delta] +', d.add);
//       lastBalanceUpdateRef.current = { ts: Date.now(), src: 'delta' };
//       setUserBalance(prev => Number(prev || 0) + Number(d.add));
//       return;
//     }

//     // абсолютное значение — не занижаем, если явного разрешения нет
//     if (typeof d.balance === 'number') {
//       const src = d.source || 'window';
//       const allowDecrease = !!d.allowDecrease; // по умолчанию запрещено
//       setUserBalance(prev => {
//         const next = Number(d.balance);
//         if (!allowDecrease && prev != null && next < prev) {
//           console.log(`[balance-updated][${src}] ignored lower absolute`, next, '<', prev);
//           return prev;
//         }
//         console.log(`[balance-updated][${src}] set`, next);
//         lastBalanceUpdateRef.current = { ts: Date.now(), src };
//         return next;
//       });
//     }
//   };

//   window.addEventListener('balance-updated', onBalance);
//   return () => window.removeEventListener('balance-updated', onBalance);
// }, []);


// //   useEffect(() => {
// //   const onBalance = (e) => {
// //     const d = e.detail || {};
// //     if (typeof d.balance === 'number') {
// //       setUserBalance(d.balance);             // абсолютное значение
// //     } else if (typeof d.add === 'number') {
// //       setUserBalance(prev => Number(prev || 0) + d.add); // поддержка delta
// //     }
// //   };
// //   window.addEventListener('balance-updated', onBalance);
// //   return () => window.removeEventListener('balance-updated', onBalance);
// // }, []);


//   // tableUpdated
//   useEffect(() => {
//     socket.on('tableUpdated', (updatedTable) => {
//       setTables((prevTables) =>
//         prevTables.map((table) =>
//           table.id === updatedTable.id ? updatedTable : table
//         )
//       );
//     });
//     return () => {
//       socket.off('tableUpdated');
//     };
//   }, [setTables]);







//   function LongBackgammonWrapper() {
//   const { gameId } = useParams();
//   const query = new URLSearchParams(useLocation().search);
//   const tableId = query.get('tableId');

//   return (
//     <LongBackgammon
//       socket={tournamentSocket}
//       isTournament
//       tableId={Number(tableId)}
//       gameId={Number(gameId)}
//     />
//   );
// }


//   return (
//     <>
//       <PresenceHeartbeat token={token} />
//       <SpinWheelOverlay show={showWheel} angle={wheelAngle} onHide={() => setShowWheel(false)} />
//       <SiteBannerPopup />
//       <Routes>
//   {/* Публичные роуты (без шапки) */}
//   <Route
//     path="/login"
//     element={<Login onLogin={handleLogin} userBalance={userBalance} setUserBalance={setUserBalance} />}
//   />
//   <Route path="/register" element={<Register />} />

//   {/* Роуты столов (кеш/турнир) – тоже без шапки */}
//   <Route path="/game/:tableId" element={<Game token={token} />} />
//   <Route path="/tournamentMatch/:gameId" element={<TournamentMatch />} />

//   <Route path="/longGame/:tableId" element={<LongBackgammon socket={longSocket} />} /> 
//   <Route path="/khachapuriGame/:tableId" element={<Khachapuri />} />
//    {/* <Route
//   path="/longTournamentMatch/:gameId"
//   element={<LongBackgammon socket={tournamentSocket} isTournament />}
// ></Route> */}
// <Route path="/longTournamentMatch/:gameId" element={<LongTournamentBackgammon />} />
//  <Route
//   path="/long-tournament/table"
//   element={<LongTournamentBackgammon />}
// />

// <Route
//   path="/big-tournament/table"
//   element={<BigTournamentBackgammon />}
// />

// <Route
//   path="/big-tournament/short/table"
//   element={<BigTournamentShortMatch />}
// />

//   <Route path="/ShortBackgammonBoard/:tableId" element={<ShortBackgammonBoard />} />

//  {/* <Route path="/poker/table/:tableId" element={<PokerTable />} /> */}
// <Route path="/poker/table/:tableId" element={<PokerTable userAvatar={userAvatar} />} />

//   {/* Все остальные роуты под общим макетом Layout (с Header) */}
//   <Route
//     element={
//       <Layout
//         username={username}
//         userBalance={userBalance}
//         onLogout={handleLogout}
//         userAvatar={userAvatar}
//         userAssets={userAssets}
//       />
//     }
//   >

//     <Route path="/forgot-password" element={<ForgotPassword />} />

//     <Route
//       path="/"
//       element={
//         <Lobby
//           token={token}
//           username={username}
//           userBalance={userBalance}
//           setUserBalance={setUserBalance}
//         />
//       }
//     />
   
//    <Route
//   path="/profile/*"
//   element={
//     <ProfileLayout
//       username={username}
//       userAssets={userAssets}          // 👈 нужно для вкладок
//       userBalance={userBalance}
//       setUsername={setUsername}
//     />
//   }
// />
 
//     {/* <Route
//       path="/tournamentsPage"
//       element={<TournamentsPage token={token} username={username} />}
//     /> */}
//       {/* <Route
//       path="/tournaments"
//       element={<TournamentsPage token={token} username={username} />}
//     /> */}
//     <Route
//    path="/tournaments"
//    element={<Navigate to="/?gt=long" replace />}
//  />
//     <Route
//     path="/quests"
//     element={<Quests />}
//   />
//     <Route path="/admin" element={<AdminPanel role={role} />} />
//     <Route path="/poker" element={<PokerLobby />} />

//     <Route path="/satellites" element={<SatellitesPage />} />
//     <Route path="/satellites/:id" element={<SatelliteDetails />} />

//     <Route
//       path="/big-tournaments"
//       element={<BigTournamentsPage />}
//     />

//     <Route
//       path="/big-tournaments/:id"
//       element={<BigTournamentDetails />}
//     />

//     {/* Любой несуществующий адрес */}
//   <Route
//     path="*"
//     element={
//       localStorage.getItem("token") ? (
//         <Navigate to="/" replace />
//       ) : (
//         <Navigate to="/login" replace />
//       )
//     }
//   />
//   </Route>
// </Routes>
//     </>
//   );
// };

// export const App = () => {
//   return (
//     <GameProvider>
//       <PokerProvider>
//         <SoundProvider>
//           <BrowserRouter>
//             <AppContent />
//           </BrowserRouter>
//         </SoundProvider>
//       </PokerProvider>
//     </GameProvider>
//   );
// };

// export default App;

